const isValidUrl = url => {
  try {
    return Boolean(new URL(url));
  } catch (e) {
    return false;
  }
};

// Reject data:, blob:, file:, javascript: etc. — only http(s) origins are trustworthy
// as a parent-page identity signal. Non-http(s) URLs produce opaque "null" origins that
// can be allowlisted by an attacker embedding the widget with a crafted url= param.
const isHttpUrl = url => /^https?:/i.test(url);

/**
 * Resolves URL of `url=` search parameter if truthy and http(s)
 * or URL of window.location.href if `url=` is falsy or non-http(s).
 * Accepts an optional href to allow unit testing without mocking window.location.
 */
export const getWindowUrl = (href = window.location.href) => {
  const location = new URL(href);
  const url = location.searchParams.get('url');
  return url && isValidUrl(url) && isHttpUrl(url) ? new URL(url) : location;
};